import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Slider from "react-slick";
import { get } from "../../_services/apiService";
import { API_URL } from "../../_services/apiUrl";

const imageUrl = process.env.REACT_APP_IMAGE_BASE_URL

const Banner = () => {
    const [loading, setLoading] = useState(false);
    const [productBannerData, setProductBannerData] = useState([]);

    const GetProductBannerDetail = async () => {
        setLoading(true);
        try {
            const response = await get(API_URL.GetProductOffer);
            if (response.isSuccess === 1) {
                setProductBannerData(response?.data);
            } else {
                setProductBannerData([]);
            }
        } catch (error) {
            setProductBannerData([]);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        GetProductBannerDetail();
    }, []);

    const settings = {
        dots: true,
        infinite: true,
        speed: 600,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 3000,
        arrows: true,
        cssEase: 'ease-in-out',
        pauseOnHover: true,
    };

    if (loading) return <div className="loading_content"><img src="./images/loading.gif" alt="" /></div>;

    return (
        <section className="section banner_page">
            <Slider {...settings}>
                {productBannerData?.map((item, index) => (
                    <div className="item" key={index}>
                        <div className="banner_inner">
                            <div className="mobile_banner">
                                <Link to={`${item?.offerUrl}`}>
                                    <img src={item?.mobilePath ? `${imageUrl}${item.mobilePath}` : './images/banner.png'} alt="" className="w-100" />
                                </Link>
                            </div>
                            <div className="desktop_banner">
                                <Link to={`${item?.offerUrl}`}>
                                    <img src={item?.imgPath ? `${imageUrl}${item.imgPath}` : './images/banner.png'} alt="" className="w-100" />
                                </Link>
                            </div>
                        </div>
                    </div>
                ))}
            </Slider>
        </section>
    );
};

export default Banner;
